/* eslint-disable class-methods-use-this */
export default class PesquisaTextualController {
  async criarComponentes() {
    import('../components/PesquisaTextual.component');
  }
}
